// Gets appropriate image (or a `null`) for passive income slide

import passiveIncomeImageMore from '../../assets/slide_pi_number_current.png';

const imageLookup = {
  more: passiveIncomeImageMore,
};

// Take a number (or some bad data form) and returns associated image (or null).
// INPUT: num (OR null/undef/bad data), whole number in millions for passive income
// OUTPUT: image [path] to correct image OR `null` (will get handled higher up)
// Note: the `null` case of bad data should be extremely rare, it's JIC
const getPassiveIncomeImage = (numberToGrab) => {
  let image = null; // Default to no image at all -- if bad data, we display nothing
  // Check that it's a whole number and larger than 78 (our minimum)
  if (numberToGrab % 1 === 0 && numberToGrab > 77) {
    // Our image library caps out at 99, so verify less than 100.
    if (numberToGrab < 100) {
      image = imageLookup[numberToGrab];
    } else { // We exceeded 100, so use the "more than 99" image
      image = imageLookup.more;
    }
  }
  return image;
};

export default getPassiveIncomeImage;
